// Дата редакции документа приходит с сервера как 2026-10-24, на экране — 24.10.2026.
export function formatRevision(revision: string): string {
  const [year, month, day] = revision.split("-");
  return `${day}.${month}.${year}`;
}
